import classNames from 'classnames';
import './OverlayModal.css';

import type { FC } from 'react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

export const OverlayModalBody: FC<Props> = (props) => (
  <div className={classNames('overlay-modal__body', props.className)}>
    {props.children}
  </div>
);
